export interface VisitPayload {
    visitorId: string;
    sessionId: string;
    path: string;
    title: string;
    referrer: string;
    utmSource: string | null;
    utmMedium: string | null;
    utmCampaign: string | null;
    language: string;
    timezone: string;
    screenWidth: number;
    screenHeight: number;
}

const VISITOR_KEY = 'truthpick_visitor_id';
const SESSION_KEY = 'truthpick_session_id';

const makeId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};

const readOrCreate = (storage: Storage, key: string) => {
    const saved = storage.getItem(key);
    if (saved) return saved;
    const value = makeId();
    storage.setItem(key, value);
    return value;
};

const campaignParams = () => {
    const hashQuery = window.location.hash.includes('?')
        ? window.location.hash.split('?')[1]
        : '';
    const params = new URLSearchParams(hashQuery || window.location.search);
    return {
        utmSource: params.get('utm_source'),
        utmMedium: params.get('utm_medium'),
        utmCampaign: params.get('utm_campaign')
    };
};

export const buildVisitPayload = (path: string): VisitPayload | null => {
    if (!path || path.startsWith('/admin')) return null;

    return {
        visitorId: readOrCreate(localStorage, VISITOR_KEY),
        sessionId: readOrCreate(sessionStorage, SESSION_KEY),
        path,
        title: document.title,
        referrer: document.referrer,
        ...campaignParams(),
        language: navigator.language || '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
    };
};

export const trackVisit = (path: string) => {
    const payload = buildVisitPayload(path);
    if (!payload) return;

    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
        const accepted = navigator.sendBeacon(
            '/api/analytics/visits',
            new Blob([body], { type: 'application/json' })
        );
        if (accepted) return;
    }

    void fetch('/api/analytics/visits', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
        credentials: 'same-origin'
    }).catch(() => undefined);
};
